import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import UserMenu from './UserMenu';
import Alert from './Alert';
import DatePicker from 'react-modern-calendar-datepicker';
import axios from 'axios';
import Tools from './Tools';

const HourlyReport = (props) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [hours, setHours] = useState(
        [
            { hourNumber: '09', range:'09:00 - 09:59'},
            { hourNumber: '10', range:'10:00 - 10:59'},
            { hourNumber: '11', range:'11:00 - 11:59'},
            { hourNumber: '12', range:'12:00 - 12:59'},
            { hourNumber: '13', range:'13:00 - 13:59'},
            { hourNumber: '14', range:'14:00 - 14:59'},
            { hourNumber: '15', range:'15:00 - 15:59'},
            { hourNumber: '16', range:'16:00 - 16:59'},
            { hourNumber: '17', range:'17:00 - 17:59'},
            { hourNumber: '18', range:'18:00 - 18:59'},
            { hourNumber: '19', range:'19:00 - 19:59'},
        ]
    );
    const [callsByHour, setCallsByHour] = useState([]);
    const [selectedDayRange, setSelectedDayRange] = useState({ from: null, to: null });

    useEffect(() => {
        getCallsByHour();
    }, []);


    const getCallsByHour=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

        let serviceParams={};
        if (selectedDayRange.from!==null){
            serviceParams.selectedDayRange = selectedDayRange;
        }

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/callsByTimeReport`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };
        setLoading(true);
        axios(options).then(response => {
            setLoading(false);
            setCallsByHour(response.data);
            //console.log('🐞DEBUG response.data:', response.data);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            setLoading(false);
        });
    }

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="10" softphoneConnectionStatus={props.softphoneConnectionStatus} />
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1 className={loading ? 'loading' : ''}>Reporte horario</h1>
                        <span class="upper">Reportes</span>
                    </div>
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues} />
                </div>

                <div className="flexRow">
                    <div className="flexCol">
                        {/* <Box type="select" name="companyId" className="x4" label="Empresa" placeholder="Seleccione ..." options={companies} onChange={handleChange} required></Box> */}
                        <div className="inputWrapper x3">
                            <label className="required">Fecha</label>
                            <DatePicker
                                value={selectedDayRange}
                                onChange={setSelectedDayRange}
                                inputPlaceholder="Filtro fechas"
                                locale={Tools.customLocaleSpanish}
                                shouldHighlightWeekends
                            />
                        </div>

                        <button className={loading ? 'default collapsed loading' : 'default collapsed'} onClick={getCallsByHour}>Generar reporte</button>
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>Rango horario</th>
                            <th>Llamadas</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hours.map((h, index) => {
                            return (
                                <tr key={index}>
                                    <td>{h.range}</td>
                                    <td>
                                        {callsByHour.find((call) => call._id === h.hourNumber) ? callsByHour.find((call) => call._id === h.hourNumber).count:0}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                {error ? (
                    <Alert className="error mgb20">Error: {error}</Alert>
                ) : null}
            </div>
        </div>
    );

}

export default HourlyReport;
